import React, { useEffect, useId, useRef } from 'react';

export default function ConfirmDialog({ title, children, confirmLabel, busy, error, onConfirm, onCancel }) {
  const dialog = useRef(null);
  const titleId = useId();
  const descriptionId = useId();
  useEffect(() => {
    const previous = document.activeElement;
    const node = dialog.current;
    node.showModal();
    return () => {
      node.close();
      const menu = previous?.closest('details');
      (menu && !menu.open ? menu.querySelector('summary') : previous)?.focus();
    };
  }, []);
  return <dialog ref={dialog} aria-labelledby={titleId} aria-describedby={descriptionId}
    onCancel={event => { event.preventDefault(); if (!busy) onCancel(); }}
    className="w-[calc(100%_-_2rem)] max-w-sm rounded-2xl border border-gray-200 bg-white p-5 shadow-xl backdrop:bg-black/40">
    <h2 id={titleId} className="text-base font-semibold text-gray-900">{title}</h2>
    <div id={descriptionId} className="mt-2 text-sm leading-relaxed text-gray-600">{children}</div>
    {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
    <div className="mt-5 flex justify-end gap-2">
      <button autoFocus type="button" disabled={busy} onClick={onCancel} className="min-h-[44px] rounded-lg border px-4 text-sm font-medium focus-visible:ring-2 focus-visible:ring-primary-500 disabled:opacity-50">Cancel</button>
      <button type="button" disabled={busy} onClick={onConfirm} className="min-h-[44px] rounded-lg bg-red-700 px-4 text-sm font-medium text-white hover:bg-red-800 focus-visible:ring-2 focus-visible:ring-red-500 disabled:opacity-50">{busy ? 'Working…' : confirmLabel}</button>
    </div>
  </dialog>;
}
